import { render, staticRenderFns } from "./KnowledgeMngSystem.vue?vue&type=template&id=44f01038&scoped=true"
import script from "./KnowledgeMngSystem.vue?vue&type=script&lang=js"
export * from "./KnowledgeMngSystem.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeMngSystem.vue?vue&type=style&index=0&id=44f01038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f01038",
  null
  
)

export default component.exports